import { render, staticRenderFns } from "./selectCategoryDialog.vue?vue&type=template&id=ed789556&scoped=true&"
import script from "./selectCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./selectCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./selectCategoryDialog.vue?vue&type=style&index=0&id=ed789556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed789556",
  null
  
)

export default component.exports